import React from "react";
import Routeur from "./components/Routeur/Routeur";

const App = () => {
  return <Routeur />;
};

export default App;
